// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"journal_wrapper__3B-Hc"};